module.exports = __webpack_public_path__ + "8e4b478308187dd4e7c77b1c9996eb2a.png";